class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

      // Collection card swatches 
   document.addEventListener("click", function(event) {
    const numberShowMore = event.target.closest(".item-swatch-more");
  
    if (!numberShowMore) return;
  
    const swatch = event.target.closest(".card-swatch ul");
    if (!swatch) return;

    const swatchWrapper = swatch.querySelector(".group-swatch");
  
    if (swatch.classList.contains("show--more")) {
      swatchWrapper.style.display = 'none';
      swatch.classList.remove("show--more");
      const span = numberShowMore.querySelector("span");
      if (span) span.textContent = "+";
    } else {
      swatch.classList.add("show--more");
        swatchWrapper.style.display = 'inline';
      const span = numberShowMore.querySelector("span");
      if (span) span.textContent = "-";
    }
  });

  const productCards = document.querySelectorAll(".card-wrapper");

  productCards.forEach((card) => {
    const swatches = card.querySelectorAll(".card-swatch .item");
  
    swatches.forEach((swatch) => {
      swatch.addEventListener('click', function () {
        // Remove 'is-active' only within this card
      
        const clickedLabel = this.querySelector("label.swatch-label");
        if(!clickedLabel) return;
        if(clickedLabel){
           // Add 'is-active' to clicked swatch's label
        swatches.forEach(item => {
          const label = item.querySelector("label.swatch-label");
          if (label) label.classList.remove("is-active");
        });
          if (clickedLabel) clickedLabel.classList.add("is-active");
    
          // Set variant ID in quick-add input
          const variantId = clickedLabel.getAttribute("data-variant-id");
          if (variantId) {
            const input = card.querySelector(".quick-add-wrapper input[name='id']");
            if (input) input.value = variantId;
          }
    
          // Update image
          const variantImg = clickedLabel.getAttribute("data-variant-img");
          const image = card.querySelector(".card__media img");
          if (variantImg && image) {
            image.src = variantImg;
            image.setAttribute("srcset", variantImg);
          }

          const price = clickedLabel.getAttribute("data-price");
          const compare_price = clickedLabel.getAttribute("data-compare-price");

          const discountPercentage = Math.round(((compare_price - price) / compare_price) * 100);
          // console.log("discountPercentage",discountPercentage);
          card.querySelector(".price__label_sale .label_sale").textContent = discountPercentage + "% Off";
          
          const priceFormatted = formatMoney(price, window.moneyFormat);
          const priceNoDecimals = priceFormatted.replace(/\.00$/, "");

          const comparePriceFormatted = formatMoney(compare_price, window.moneyFormat);
          const comparePriceNoDecimals = comparePriceFormatted.replace(/\.00$/, "");

          card.querySelector(".price-item.price-item--regular").textContent = comparePriceNoDecimals;
          card.querySelector(".price-item.price-item--sale").textContent = priceNoDecimals;
  
          // Set button disable or enable
          const checkAvailability = clickedLabel.getAttribute("data-available");
          console.log("checkAvailability",checkAvailability);
          if(checkAvailability == 'false'){
            const quickButton = card.querySelector(".quick-add-wrapper .quick-add__submit");
            quickButton.querySelector(".btn-text").textContent = 'SOLD OUT';
            quickButton.setAttribute('disabled','');
          }else{
            const quickButton = card.querySelector(".quick-add-wrapper .quick-add__submit");
            if(card.closest('section')?.classList.contains('everyday-wrapper')){
              quickButton.querySelector(".btn-text").textContent = 'ADD';
            }else{
              quickButton.querySelector(".btn-text").textContent = 'ADD TO CART';
            }
            quickButton.removeAttribute('disabled');
          }
        }
      });
    });
  });

    document.querySelectorAll('.SortByWrapper').forEach((wrapper) => {
      const selected = wrapper.querySelector('.SortBySelected .selected-text');
      const options = wrapper.querySelector('.SortByOptions');
      const items = options.querySelectorAll('li');
      const sortInput = wrapper.querySelector('input[name="sort_by"]');

      const firstItem = items[0];

      if (firstItem) {
        selected.textContent = firstItem.textContent;
        sortInput.value = firstItem.dataset.value;

        items.forEach(item => item.classList.remove('active'));
        firstItem.classList.add('active');
      }

      wrapper.querySelector('.SortBySelected').addEventListener('click', () => {
        const isVisible = options.style.display === 'block';

        document.querySelectorAll('.SortByOptions').forEach(opt => {
          opt.style.display = 'none';
          opt.classList.remove('open'); 
        });

        if (!isVisible) {
          options.style.display = 'block';
          options.classList.add('open');
        }
      });

      items.forEach(li => {
        li.addEventListener('click', () => {
          selected.textContent = li.textContent;
          sortInput.value = li.dataset.value;

          options.style.display = 'none';

          items.forEach(item => item.classList.remove('active'));
          li.classList.add('active');

          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', li.dataset.value);
          window.location.href = url.toString();
        });
      });

      const closeDropdown = (e) => {
        if (!wrapper.contains(e.target)) {
          options.style.display = 'none';
          options.classList.remove('open');
        }
      };

      ['click', 'touchstart'].forEach(evt => {
        document.addEventListener(evt, closeDropdown);
      });
    });


    
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }

    // var endlessScroll = new Ajaxinate({
    //   container: '#product-grid',
    //   pagination: '#AjaxinatePagination'
    // });
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.inputs = this.querySelectorAll('input.field__input');
//     this.sliderMin = this.querySelector('.range-min');
//     this.sliderMax = this.querySelector('.range-max');
//     this.rangeFill = this.querySelector('.range-fill');

//     this.inputs.forEach((el) => {
//       el.addEventListener('change', this.onRangeChange.bind(this));
//       el.addEventListener('keydown', this.onKeyDown.bind(this));
//     });

//     this.sliderMin?.addEventListener('input', this.syncInputsFromSlider.bind(this));
//     this.sliderMax?.addEventListener('input', this.syncInputsFromSlider.bind(this));

//     this.setMinAndMaxValues();
//     this.updateSliderFill();
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//     this.syncSlidersFromInputs();
//     this.updateSliderFill();
//   }

//   onKeyDown(event) {
//     const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
//     if (!event.key.match(pattern)) event.preventDefault();
//   }

//   setMinAndMaxValues() {
//     const [minInput, maxInput] = this.inputs;
//     if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('data-min', 0);
//     if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('data-min'));
//     const max = Number(input.getAttribute('data-max'));
//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }

//   syncInputsFromSlider() {
//     const min = Math.min(Number(this.sliderMin.value), Number(this.sliderMax.value));
//     const max = Math.max(Number(this.sliderMin.value), Number(this.sliderMax.value));
//     this.inputs[0].value = min;
//     this.inputs[1].value = max;
//     this.updateSliderFill();
//   }

//   syncSlidersFromInputs() {
//     this.sliderMin.value = this.inputs[0].value || 0;
//     this.sliderMax.value = this.inputs[1].value || this.sliderMax.getAttribute('max');
//   }

//   updateSliderFill() {
//     const min = parseInt(this.sliderMin.value);
//     const max = parseInt(this.sliderMax.value);
//     const range = parseInt(this.sliderMax.getAttribute('max')) - parseInt(this.sliderMin.getAttribute('min'));
//     const percentMin = ((min - this.sliderMin.min) / range) * 100;
//     const percentMax = ((max - this.sliderMin.min) / range) * 100;
//     this.rangeFill.style.left = percentMin + '%';
//     this.rangeFill.style.width = (percentMax - percentMin) + '%';
//   }
// }

// customElements.define('price-range', PriceRange);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input.field__input');
    this.sliderMin = this.querySelector('.range-min');
    this.sliderMax = this.querySelector('.range-max');
    this.rangeFill = this.querySelector('.range-fill');

    this.inputs.forEach((el) => {
      el.addEventListener('change', this.onRangeChange.bind(this));
      el.addEventListener('keydown', this.onKeyDown.bind(this));
    });

    this.sliderMin?.addEventListener('input', this.syncInputsFromSlider.bind(this));
    this.sliderMax?.addEventListener('input', this.syncInputsFromSlider.bind(this));

    this.setMinAndMaxValues();
    this.updateSliderFill();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();

    const [minInput, maxInput] = this.inputs;
    const min = parseFloat(minInput.value) || 0;
    const max = parseFloat(maxInput.value) || 0;

    // Enforce min <= max
    if (min > max) {
      maxInput.value = min;
    }

    this.syncSlidersFromInputs();
    this.updateSliderFill();
  }

  onKeyDown(event) {
    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const [minInput, maxInput] = this.inputs;
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    let value = parseFloat(input.value);
    const min = parseFloat(input.getAttribute('data-min')) || 0;
    const max = parseFloat(input.getAttribute('data-max')) || 0;

    if (isNaN(value)) value = min;
    if (value < min) value = min;
    if (value > max) value = max;

    input.value = value;
  }

  syncInputsFromSlider() {
    let min = Math.min(Number(this.sliderMin.value), Number(this.sliderMax.value));
    let max = Math.max(Number(this.sliderMin.value), Number(this.sliderMax.value));

    // Lock sliders to never cross
    this.sliderMin.value = min;
    this.sliderMax.value = max;

    this.inputs[0].value = min;
    this.inputs[1].value = max;

    this.setMinAndMaxValues();
    this.updateSliderFill();
  }

  syncSlidersFromInputs() {
    const min = parseFloat(this.inputs[0].value) || 0;
    const max = parseFloat(this.inputs[1].value) || parseFloat(this.sliderMax.getAttribute('max')) || 0;

    this.sliderMin.value = min;
    this.sliderMax.value = max;
  }

  updateSliderFill() {
    const min = parseInt(this.sliderMin.value);
    const max = parseInt(this.sliderMax.value);
    const range = parseInt(this.sliderMax.getAttribute('max')) - parseInt(this.sliderMin.getAttribute('min'));

    const percentMin = ((min - this.sliderMin.min) / range) * 100;
    const percentMax = ((max - this.sliderMin.min) / range) * 100;

    this.rangeFill.style.left = percentMin + '%';
    this.rangeFill.style.width = (percentMax - percentMin) + '%';
  }
}

customElements.define('price-range', PriceRange);


// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('input').forEach((element) => {
//       element.addEventListener('change', this.onRangeChange.bind(this));
//       element.addEventListener('keydown', this.onKeyDown.bind(this));
//     });
//     this.setMinAndMaxValues();
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//   }

//   onKeyDown(event) {
//     if (event.metaKey) return;

//     const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
//     if (!event.key.match(pattern)) event.preventDefault();
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('data-min', 0);
//     if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('data-min'));
//     const max = Number(input.getAttribute('data-max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }
// }

// customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
